import { Component, NgZone } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";

import { APIServiceProvider } from "./../../../common/services/api.service";
import { HelperServiceProvider } from "./../../../common/services/helper.service";

@Component({
	selector: "page-settlementcancelled",
	templateUrl: "settlementcancelled.html"
})
export class SettlementCancelledPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public zone: NgZone,
		public apiHelper: APIServiceProvider
	) {}

	public postParams: any = {
		status: 0
	};
	public settlements: any = [];
	public pagination = null;
	public searchText = null;

	public settlementUrl = "settlement/all";

	ionViewDidLoad() {
		this.getSettlements(this.settlementUrl);
	}

	getSettlements(url, refresh?) {
		this.apiHelper.post(url, this.postParams).subscribe(
			response => {
				this.settlements = response["data"]["data"];
				this.pagination = response["data"];
				if (refresh) {
					refresh.complete();
				}
			},
			error => {}
		);
	}

	doRefresh(refresher) {
		this.getSettlements(this.settlementUrl, refresher);
	}

	doInfiniteScroll(event) {
		if (
			!this.pagination.next_page_url ||
			this.pagination.next_page_url === "" ||
			this.pagination.next_page_url === null ||
			this.pagination.next_page_url === "null"
		) {
			event.complete();
			return;
		} else {
			this.apiHelper
				.post(null, this.postParams, this.pagination["next_page_url"])
				.subscribe(
					response => {
						this.settlements = this.settlements.concat(
							response["data"]["data"]
						);
						this.pagination = response["data"];
						event.complete();
					},
					error => {}
				);
			return;
		}
	}

	search(text) {
		this.postParams["search"] = this.searchText;
		this.getSettlements(this.settlementUrl);
	}

	clearSearch(text) {
		delete this.postParams["search"];
		this.getSettlements(this.settlementUrl);
	}
}



// WEBPACK FOOTER //
// ./src/pages/settlement/settlementcancelled/settlementcancelled.ts